import script from "./AdminKanbanView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminKanbanView.vue?vue&type=script&setup=true&lang=js"

import "./AdminKanbanView.vue?vue&type=style&index=0&id=a32697c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a32697c6"]])

export default __exports__